<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'schedule.add_load' | translate }}
    v-card-content
      v-text-field.mb-3(
        :focus="true"
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="form.name")
      .cols__1
        .cols__1
          v-select.mb-3(
            :label="$t('base.period')"
            :options="periods"
            v-model="form.period")
        //- v-btn(
        //-   gray
        //-   square
        //-   @click="modals.showCreateLoading = true")
        //-   v-icon(
        //-     font-size=".8"
        //-     icon="plus")
      .cols__1
        .cols__1
          v-select.mb-3(
            :label="$t('base.ration')"
            :options="rationsList"
            v-model="form.ration")
      .cols__1
        .cols__1
          v-multiselect.mb-3(
            :label="$t('base.animal_groups')"
            :options="groupsList"
            v-model="form.groups")
      .cols__1
        .cols__1
          v-select.mb-3(
            :label="$t('base.mixer')"
            :options="mixers"
            v-model="form.mixer")
      v-text-field.mb-3(
        :label="$t('base.mix_time')"
        v-model="form.mix_time")
      v-switch.mb-3(
        :label="$t('base.auto_load')"
        v-model="form.auto_load")
      v-switch(
        :label="$t('base.activate_planning')"
        v-model="form.is_active")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate") {{ 'base.add' | translate }}
    //- v-dialog(
    //-   max-width="335"
    //-   v-model="modals.showCreateLoading")
    //-   create-loading-modal(
    //-     @update="loadPeriods"
    //-     @close="modals.showCreateLoading = false")
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

import CreateLoadingModal from './CreateLoadingModal'

export default {
  name: 'CreatePlanningModal',

  components: {
    CreateLoadingModal
  },

  data: () => ({
    modals: {
      showCreateLoading: false
    },
    form: {
      name: '',
      auto_load: false,
      is_active: true,
      mix_time: 15,
      period: null,
      mixer: null,
      ration: null,
      groups: []
    },
    errors: {
      name: null
    },
    mixers: [],
    periods: [],
    loading: false
  }),

  mounted () {
    this.loadData()
  },

  computed: {
    ...mapGetters('groups', [
      'groupsList'
    ]),

    ...mapGetters('rations', [
      'rationsList'
    ]),

    allowCreateLoading () {
      return this.hasPermission('loading', 'add')
    },

    allowViewLoadings () {
      return this.hasPermission('loading', 'view')
    },

    allowViewRations () {
      return this.hasPermission('ration', 'view')
    },

    allowViewGroups () {
      return this.hasPermission('group', 'view')
    },

    allowViewMixers () {
      return this.hasPermission('mixer', 'view')
    }
  },
  mixins: [formErrorsMixin],
  methods: {
    ...mapActions('schedule', [
      'createSchedule'
    ]),

    ...mapActions('mixers', [
      'loadMixers'
    ]),

    ...mapActions('groups', [
      'loadGroupsList'
    ]),

    ...mapActions('rations', [
      'loadRationsList'
    ]),

    async loadData () {
      if (this.allowViewLoadings) {
        this.loadPeriods()
      }
      const params = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      if (this.allowViewRations) {
        this.loadRationsList(params)
      }
      if (this.allowViewGroups) {
        this.loadGroupsList(params)
      }
      if (this.allowViewMixers) {
        this.mixers = await this.loadMixers(params)
      }
    },

    async loadPeriods () {
      const params = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      const { data } = await api.loadings.list(params)
      this.periods = data
    },

    async onCreate () {
      if (this.validateData()) {
        if (this.form.name === '') {
          this.form.name = this.form.ration.name
        }
        const payload = {
          name: this.form.name,
          farm: this.$route.params.farm_id,
          schedule_loading: {
            loading: this.form.period
          },
          schedule_mixer: {
            mixer: this.form.mixer
          },
          schedule_ration: {
            ration: this.form.ration,
            ingredients: []
          },
          schedule_groups: this.form.groups
            .map(item => ({
              group: item.id,
              coefficient: 100,
              ordering: 1
            })),
          coefficient: 100,
          auto_load: this.form.auto_load,
          is_active: this.form.is_active,
          ordering: 1,
          mix_time: Math.floor(+this.form.mix_time * 60)
        }
        this.loading = true
        await this.createSchedule(payload)
        this.$store.dispatch('planning/markPlanningCreated')
        this.loading = false
        this.$emit('update')
        this.$emit('close')
      }
    },

    validateData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
        return false
      } else if (this.form.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
        return false
      }

      if (!this.form.period) {
        this.$toasted.show(this.$t('Необхідно вибрати період'))
        return false
      }

      if (!this.form.ration) {
        this.$toasted.show(this.$t('info.select_ration'))
        return false
      }

      if (!this.form.mixer) {
        this.$toasted.show(this.$t('info.select_mixer'))
        return false
      }

      if (!this.form.groups.length) {
        this.$toasted.show(this.$t('info.select_animal_group'))
        return false
      }
      return true
    }
  }
}
</script>
